import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport, WizModal} = component_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      0: '培训视频',
      1: '店端视频',
    },
    state: {
      0: '取消发布',
      1: '发布',
      2: '屏蔽'
    },
    commentState: {
      0: '关闭',
      1: '开启'
    },
    shareState: {
      0: '关闭',
      1: '开启'
    }
  }
  return values[type][key]
}

class ShortVideoManager extends WizContainer {
  componentName = 'shortVideoManager'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'title',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '介绍',
        field: 'intro',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '标签',
        field: 'labelIds',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分类',
        field: 'categoryIds',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布类型',
        field: 'type',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布终端',
        field: 'publishTerminalCh',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布人',
        field: 'fullName',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布时间',
        field: 'releaseTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      // {
      //   headerName: '评论开关',
      //   field: 'commentState',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
      // {
      //   headerName: '分享开关',
      //   field: 'shareState',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['type'] =  _getValue('type', e['type'])
        e['state'] =  _getValue('state', e['state'])
        // e['commentState'] =  _getValue('commentState', e['commentState'])
        // e['shareState'] =  _getValue('shareState', e['shareState'])
        let labelIds = []
        e['labelIds'] && e['labelIds'].length && e['labelIds'].forEach(item => {
          labelIds.push(item.name)
        })
        e['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''
        let categoryIds = []
        e['categoryIds'] && e['categoryIds'].length && e['categoryIds'].forEach(item => {
          categoryIds.push(item.name)
        })
        e['categoryIds'] = categoryIds && categoryIds.length > 0 ? categoryIds.join(",") : ''
      })
      WizBrowserExport({
        title: '短视频信息',
        sheetName: '短视频信息',
        columns: columnDefs,
        rows: data,
        filename: '短视频信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        enable: this._handleCMD,
        delete: this._handleCMD,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ShortVideoManager);
